export const COLUMNS = [
  {
    sortKey: "name",
    sortable: true,
    label: "Name",
  },
  {
    sortKey: "community.name",
    sortable: true,
    label: "Community",
  },
  {
    sortKey: "screening_type.id",
    sortable: true,
    label: "Screening Type",
  },
  {
    sortKey: "status",
    sortable: true,
    label: "Decision",
  },
 
  {
    sortKey: "autoscore",
    sortable: true,
    label: "Recommendation",
  },
  {
    sortKey: "created_at",
    sortable: true,
    label: "Submitted",
  },
];

export const AUTOSCORE = {
  pass: { label: "Pass", variant: "success" },
  conditional: { label: "Conditional", variant: "success" },
  decline: { label: "Declined", variant: "danger" },
};
